import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {LayerTypeFilter} from '../../../../configuration/model/LayerTypeFilter';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MapThemeEditorComponent } from '../../map-theme-editor/map-theme-editor.component';

export interface TimeMapConfig {
  reset: boolean;
  defaultLegendSettings: LayerTypeFilter;
  legendSettings: LayerTypeFilter;
}

@Component({
  selector: 'app-time-map-config',
  templateUrl: './time-map-config.component.html',
  styleUrl: './time-map-config.component.scss',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatDialogContent,
    MapThemeEditorComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
})
export class TimeMapConfigComponent {
  constructor(
    public dialogRef: MatDialogRef<TimeMapConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TimeMapConfig
  ) {}

  reset() {
    this.data.legendSettings = LayerTypeFilter.copy(this.data.defaultLegendSettings);
    this.data.reset = true;
  }

  isDefault() {
    return this.data.reset;
  }

  onChange(legendSettings: LayerTypeFilter) {
    this.data.reset = false;
  }
}
